'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _number = require('./../number');

var _number2 = _interopRequireDefault(_number);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var totalStyles = {
  backgroundColor: 'rgba(0,0,0,.05)',
  fontWeight: 'bold'
};

var getLatestSupportingData = function getLatestSupportingData(supportingData) {
  var latestSupportingData = void 0;

  if (supportingData && supportingData.length) {
    var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
    var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
      return o.createdDate;
    }));
    latestSupportingData = ordered[0];
  }

  return latestSupportingData;
};

var VoxiReportTotalsRow = function VoxiReportTotalsRow(props) {
  var posts = props.posts,
      withDeleteButton = props.withDeleteButton;


  var viewsTotal = _lodash2.default.sumBy(posts, function (post) {
    if (post.trackedAsset.platform === 'YOUTUBE') {
      var latestStatistic = _lodash2.default.last(post.statistics);
      return latestStatistic.viewCount || 0;
    }

    if (post.trackedAsset.platform === 'INSTAGRAM' && post.trackedAsset.assetType === 'STORY') {
      return post.latestStatistic.openCount || 0;
    }

    if (post.trackedAsset.platform === 'INSTAGRAM' || post.trackedAsset.platform === 'FACEBOOK') {
      return post.latestStatistic.viewCount || 0;
    }
    return 0;
  });

  var totalImpressions = _lodash2.default.sumBy(posts, function (post) {
    if (post.trackedAsset.platform === 'FACEBOOK' && post.latestStatistic.insights) {
      return post.latestStatistic.insights.totalVideoImpressions || 0;
    }
    if (post.trackedAsset.platform === 'INSTAGRAM' && post.latestStatistic.insights) {
      return post.latestStatistic.insights.impressions || 0;
    }
    var latestSupportingData = getLatestSupportingData(post.trackedAsset.supportingData);
    if (latestSupportingData) {
      return latestSupportingData.impressions || 0;
    }
    return 0;
  });

  var totalActions = _lodash2.default.sumBy(posts, function (post) {
    var latestSupportingData = getLatestSupportingData(post.trackedAsset.supportingData);
    if (latestSupportingData) {
      return latestSupportingData.actions || 0;
    }
    return 0;
  });

  var totalReach = _lodash2.default.sumBy(posts, function (post) {
    if (post.trackedAsset.platform === 'FACEBOOK' && post.latestStatistic.insights) {
      return post.latestStatistic.insights.totalVideoImpressionsUnique || 0;
    }
    if (post.trackedAsset.platform === 'INSTAGRAM' && post.latestStatistic.insights) {
      return post.latestStatistic.insights.reach || 0;
    }
    var latestSupportingData = getLatestSupportingData(post.trackedAsset.supportingData);
    if (latestSupportingData) {
      return latestSupportingData.reach || 0;
    }
    return 0;
  });

  var likesTotal = _lodash2.default.sumBy(posts, function (post) {
    if (post.trackedAsset.platform === 'YOUTUBE') {
      var latestStatistic = _lodash2.default.last(post.statistics);
      return latestStatistic.likeCount || 0;
    }
    if (post.trackedAsset.platform === 'TWITTER') {
      return post.latestStatistic.likeCount || 0;
    }
    if (post.trackedAsset.platform === 'INSTAGRAM' || post.trackedAsset.platform === 'FACEBOOK') {
      return post.latestStatistic.likeCount || 0;
    }
    return 0;
  });

  var totalComments = _lodash2.default.sumBy(posts, function (post) {
    if (post.trackedAsset.platform === 'YOUTUBE') {
      var latestStatistic = _lodash2.default.last(post.statistics);
      return latestStatistic.commentCount || 0;
    }
    if (post.trackedAsset.platform === 'FACEBOOK') {
      return post.latestStatistic.commentCount || 0;
    }
    if (post.trackedAsset.platform === 'INSTAGRAM') {
      return post.latestStatistic.commentCount || 0;
    }
    return 0;
  });

  var totalShares = _lodash2.default.sumBy(posts, function (post) {
    var YT_SHARE_INDEX = 7;
    var platform = post.trackedAsset.platform;


    if (platform === 'FACEBOOK') {
      return post.latestStatistic.shareCount || 0;
    }
    if (platform === 'TWITTER') {
      return post.latestStatistic.retweetCount || 0;
    }
    var insights = post.latestStatistic.insights;

    if (platform === 'YOUTUBE' && insights) {
      var shareCount = _lodash2.default.sumBy(insights.viewingByCountry, function (o) {
        return o[YT_SHARE_INDEX];
      });
      return shareCount;
    }
    return 0;
  });

  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    { style: totalStyles },
    _react2.default.createElement(_semanticUiReact.Table.Cell, null),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(
        'span',
        null,
        'Totals (',
        posts.length,
        ' assets)'
      )
    ),
    _react2.default.createElement(_semanticUiReact.Table.Cell, null),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_number2.default, { number: viewsTotal, label: 'views' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      totalImpressions && _react2.default.createElement(_number2.default, { number: totalImpressions, label: 'impressions' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      totalReach && _react2.default.createElement(_number2.default, { number: totalReach, label: 'reach' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      totalActions && _react2.default.createElement(_number2.default, { number: totalActions, label: 'actions' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_number2.default, { number: likesTotal, label: 'likes' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_number2.default, { number: totalComments, label: 'comments' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_number2.default, { number: totalShares, label: 'shares' })
    ),
    _react2.default.createElement(_semanticUiReact.Table.Cell, null),
    withDeleteButton && _react2.default.createElement(_semanticUiReact.Table.Cell, null)
  );
};

VoxiReportTotalsRow.propTypes = {
  posts: _propTypes2.default.array.isRequired,
  withDeleteButton: _propTypes2.default.bool
};

VoxiReportTotalsRow.defaultProps = {
  withDeleteButton: false
};

exports.default = VoxiReportTotalsRow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/voxi-report-totals-row/index.js
// module id = 2297
// module chunks = 1